exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/portfolio-projects.js-WebpackMultiOutput";